"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFailureModes = void 0;
const capability_1 = require("../../capability");
const _util_1 = require("../_util");
const getFailureModes = (device) => {
    const [filter, membrane] = device.consumables;
    const alarms = device.alarms.map(({ alarm }) => alarm);
    return {
        sanitization: [(0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.UvError)],
        dripTrayAndLeak: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.ErrorLeakInternal),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.ErrorLeakExternal),
        ],
        enhancements: [],
        heatingStatus: [],
        chillingStatus: [],
        waterQuality: [
            (0, _util_1.getFailureModeNullableSlot)(filter, capability_1.Consumable.Definition.GlobalTanklessROFilter.GlobalTanklessROFilter),
            (0, _util_1.getFailureModeNullableSlot)(membrane, capability_1.Consumable.Definition.GlobalTanklessROMembrane.GlobalTanklessROMembrane),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.MembraneFailure),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.Tds1High),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.Tds1NoTds),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.Tds2NoTds),
        ],
    };
};
exports.getFailureModes = getFailureModes;
//# sourceMappingURL=failure-mode.js.map